module.exports = __webpack_public_path__ + "static/kayak-840ad80d0e4250a7cb1cf544aeb704ff.jpg";